// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__mcGtK","done":"done__isUNH","loader":"loader__rEozo","rotating":"rotating__TQvss"};